import { gql } from "@apollo/client";

const GET_ALL_GALLERIES = gql`
  query findAllAlbum(
    $filter: ListAlbumInput
    $platformPublicId: String
    $page: Int
    $limit: Int
    $organizationPublicId: String
  ) {
    findAllAlbum(
      filter: $filter
      platformPublicId: $platformPublicId
      page: $page
      limit: $limit
      organizationPublicId: $organizationPublicId
    ) {
      albums {
        id
        title
        thumbnail
        isSpecificTournament
        albumCustomEvent
        albumTags
        date
        media {
          id
        }
        createdBy {
          name
          surname
        }
        league {
          id
          title
        }
        tournament {
          id
          title
        }
      }
      total
    }
  }
`;

export default GET_ALL_GALLERIES;
